export enum UpmPlantsHierarchyType {
  Global = 'Global',
  ManagementArea = 'ManagementArea',
  Region = 'Region',
  SubRegion = 'SubRegion',
  Country = 'Country',
  Cluster = 'Cluster',
  Plant = 'Plant'
}

export interface UpmPlantsAlternativeId {
  id: string
  plantsHierarchyElementId: string
  name: string
  source: string
}

export interface UpmPlantsHierarchyNode {
  name: string
  type: UpmPlantsHierarchyType
  hierarchyId: string
  isoCountryCode?: string
  children: UpmPlantsHierarchyNode[]
  alternativeIds?: UpmPlantsAlternativeId[]
}

export interface UpmPlantsHierarchyResponse {
  hierarchy: UpmPlantsHierarchyNode
}
